globalThis.InputMirror = (function() {
  function InputMirror($html) {
    this.$html = $html;
    this.$sourceInput = this.$html.find('*[data-target="input-mirror.sourceInput"]');
    this.$mirrorInputs = this.$html.find('*[data-target="input-mirror.mirrorInput"]');

    this.init();
  }

  InputMirror.init = function($ctx) {
    ($ctx || $('body')).find('*[data-sb-controller="input-mirror"]').each(function() {
      new InputMirror($(this));
    });
  }

  InputMirror.prototype = {
    init: function() {
      this.initEvents();
    },
    initEvents: function() {
      var moduleInstance = this;

      moduleInstance.$sourceInput.on('input', function() {
        var value = moduleInstance.$sourceInput.val();

        moduleInstance.$mirrorInputs.each(function() {
          var $this = $(this);

          switch($this.data('mirror-mode')) {
            case 'slugify':
              $this.val(utils.slugify(value));
              break;
            default:
              $this.val(value);
              break;
          }
        });
      });
    }
  }

  return InputMirror;
})();
